/**
 * Benachrichtigen lassen (Klaviyo Back in Stock)
 *
 * Gehoert zu snippets/hess-notify-button.liquid und snippets/hess-notify-modal.liquid.
 *
 * Zwei Flaechen, zwei Mechaniken, weil Zest sie unterschiedlich rendert:
 *
 * 1. Buybox (snippets/main-product-blocks.liquid)
 *    product-sections.js holt bei jedem Variantenwechsel die Produktseite neu und ersetzt den innerHTML
 *    von #buy-buttons. Ob der Trigger oder der Warenkorb-Button erscheint, entscheidet also Liquid
 *    serverseitig. Hier ist nichts zu schalten, nur der Klick muss per Delegation ankommen.
 *
 * 2. Sticky-Leiste (sections/sticky-atc-bar.liquid)
 *    sticky-atc-bar.js rendert nie neu, es schaltet den Warenkorb-Button per updateButton() um.
 *    Dort liegen beide Buttons im Markup und dieses Skript blendet sie um.
 */
(function () {
  'use strict';

  // ID aus snippets/modal.liquid: der Theme-Rahmen praefixt die uebergebene id mit "PopupModal-".
  var MODAL_ID = 'PopupModal-hess-notify';
  var KLAVIYO_REVISION = '2024-10-15';
  var EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  // Bereits eingetragene Varianten, damit der Button beim Wiederkommen "Wir benachrichtigen dich"
  // zeigt und niemand ein zweites Mal klickt.
  //
  // localStorage statt Cookie: Der Wert wird nur im Browser gebraucht. Ein Cookie ginge bei jedem
  // Request an Shopify mit, und Liquid koennte es trotzdem nicht lesen, der Vorteil waere also keiner.
  //
  // Mit Ablauf, weil Klaviyo die Eintragung beim Benachrichtigen verbraucht. Ohne Ablauf wuerde der
  // Button spaeter faelschlich behaupten, jemand stehe noch auf der Liste.
  var STORAGE_KEY = 'hess-notify';
  var TTL_MS = 90 * 24 * 60 * 60 * 1000;
  var stickyVariants = null;

  // localStorage kann werfen (Privates Fenster, blockierte Site-Daten). Fehler bedeuten hier
  // schlicht "nichts gemerkt", die Eintragung selbst ist davon nicht betroffen.
  function saveSubs(data) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (e) {}
  }

  function loadSubs() {
    var data;
    try {
      data = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '{}');
    } catch (e) {
      return {};
    }
    if (!data || typeof data !== 'object') return {};

    var cutoff = Date.now() - TTL_MS;
    var kept = {};
    var expired = false;
    Object.keys(data).forEach(function (id) {
      if (typeof data[id] === 'number' && data[id] > cutoff) {
        kept[id] = data[id];
      } else {
        expired = true;
      }
    });
    if (expired) saveSubs(kept);
    return kept;
  }

  function rememberSub(variantId) {
    var subs = loadSubs();
    subs[variantId] = Date.now();
    saveSubs(subs);
  }

  function markTrigger(trigger, done) {
    var label = trigger.querySelector('[data-hess-notify-trigger-label]');
    if (label) {
      label.textContent = done
        ? trigger.dataset.labelDone || label.textContent
        : trigger.dataset.labelDefault || label.textContent;
    }
    trigger.classList.toggle('is-subscribed', done);
  }

  function applyStoredState() {
    var subs = loadSubs();
    document.querySelectorAll('[data-hess-notify-trigger]').forEach(function (trigger) {
      markTrigger(trigger, !!subs[trigger.dataset.variantId]);
    });
  }

  function modal() {
    return document.getElementById(MODAL_ID);
  }

  // Konfiguration und Zustand haengen am inneren Wrapper, weil snippets/modal.liquid
  // keine eigenen Attribute am <modal-dialog> durchreicht.
  function root() {
    var el = modal();
    return el ? el.querySelector('.hess-notify') : null;
  }

  function form() {
    var el = root();
    return el ? el.querySelector('#HessNotifyForm') : null;
  }

  function setLabel(text) {
    var el = root();
    if (!el) return;
    el.querySelectorAll('[data-hess-notify-label]').forEach(function (node) {
      node.textContent = text;
    });
  }

  /** state: '' | 'success' | 'invalid' | 'error'. Leerer String blendet alle Meldungen aus. */
  function showState(state) {
    var el = root();
    if (!el) return;
    el.querySelectorAll('[data-hess-notify-state]').forEach(function (node) {
      node.hidden = node.dataset.hessNotifyState !== state;
    });
  }

  function setBusy(busy) {
    var el = root();
    var button = el ? el.querySelector('[data-hess-notify-submit]') : null;
    if (!button) return;
    button.disabled = busy;
    if (busy) {
      button.setAttribute('aria-busy', 'true');
    } else {
      button.removeAttribute('aria-busy');
    }
  }

  function openModal(trigger) {
    var el = modal();
    var cfg = root();
    var formEl = form();
    if (!el || !cfg || !formEl) return;

    var variantId = trigger.dataset.variantId;
    cfg.dataset.variantId = variantId;
    setLabel(trigger.dataset.variantLabel || '');
    setBusy(false);

    if (loadSubs()[variantId]) {
      formEl.hidden = true;
      showState('success');
    } else {
      formEl.hidden = false;
      showState('');
    }

    el.show(trigger);
  }

  function onDocumentClick(event) {
    if (!event.target || !event.target.closest) return;

    if (event.target.closest('[data-hess-notify-again]')) {
      event.preventDefault();
      var formEl = form();
      if (!formEl) return;
      formEl.hidden = false;
      showState('');
      setBusy(false);
      var emailInput = formEl.querySelector('[name="email"]');
      if (emailInput) {
        emailInput.value = '';
        emailInput.focus();
      }
      return;
    }

    var trigger = event.target.closest('[data-hess-notify-trigger]');
    if (!trigger) return;
    event.preventDefault();
    openModal(trigger);
  }

  function subscribeBackInStock(companyId, variantId, email) {
    var payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: { data: { type: 'profile', attributes: { email: email } } },
          channels: ['EMAIL']
        },
        relationships: {
          variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } }
        }
      }
    };

    return fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: KLAVIYO_REVISION },
      body: JSON.stringify(payload)
    }).then(function (response) {
      if (!response.ok) throw new Error('Klaviyo ' + response.status);
      return response;
    });
  }

  /**
   * Newsletter-Eintragung auf dieselbe Liste wie snippets/newsletter-mc.liquid.
   * Fehler werden bewusst verschluckt: Eine gescheiterte Newsletter-Anmeldung darf die
   * Warteliste nicht als fehlgeschlagen anzeigen, die ist an der Stelle schon gespeichert.
   */
  function subscribeNewsletter(companyId, listId, email) {
    if (!listId) return;
    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: { email: email },
              subscriptions: {
                email: { marketing: { consent: 'SUBSCRIBED', custom_source: 'Benachrichtigen lassen' } }
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: listId } } }
      }
    };

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: KLAVIYO_REVISION },
      body: JSON.stringify(payload)
    }).catch(function () {});
  }

  function onSubmit(event) {
    event.preventDefault();

    var cfg = root();
    var formEl = form();
    if (!cfg || !formEl) return;

    var honeypot = formEl.querySelector('[name="email_address_check"]');
    if (honeypot && honeypot.value !== '') return;

    var emailInput = formEl.querySelector('[name="email"]');
    var email = emailInput ? emailInput.value.trim() : '';
    if (!EMAIL_PATTERN.test(email)) {
      showState('invalid');
      if (emailInput) emailInput.focus();
      return;
    }

    var variantId = cfg.dataset.variantId;
    var newsletter = formEl.querySelector('[name="newsletter"]');

    setBusy(true);
    showState('');

    subscribeBackInStock(cfg.dataset.companyId, variantId, email)
      .then(function () {
        if (newsletter && newsletter.checked) {
          subscribeNewsletter(cfg.dataset.companyId, cfg.dataset.listId, email);
        }
        rememberSub(variantId);
        applyStoredState();
        formEl.hidden = true;
        showState('success');
      })
      .catch(function () {
        showState('error');
        setBusy(false);
      });
  }

  // ---------------------------------------------------------------------------------------------
  // Sticky-Leiste
  // ---------------------------------------------------------------------------------------------

  function stickyBar() {
    return document.querySelector('.sticky-atc-bar');
  }

  function stickyVariantData() {
    if (stickyVariants) return stickyVariants;
    var bar = stickyBar();
    var json = bar ? bar.querySelector('script[type="application/json"]') : null;
    if (!json) return null;
    try {
      stickyVariants = JSON.parse(json.textContent);
    } catch (e) {
      stickyVariants = null;
    }
    return stickyVariants;
  }

  function stickyLabel(variant) {
    var title = document.querySelector('.sticky-atc-bar__product-title');
    var productTitle = title ? title.textContent.trim() : '';
    if (!variant || !variant.title || variant.title === 'Default Title') return productTitle;
    return productTitle + ' (' + variant.title + ')';
  }

  function updateSticky(variant) {
    var bar = stickyBar();
    if (!bar) return;

    var trigger = bar.querySelector('[data-hess-notify-trigger]');
    var addButton = bar.querySelector('[name="add"]');
    var dynamicButton = bar.querySelector('.f-product-form__button-dynamic');
    if (!trigger) return;

    // Kein variant heisst: die Optionskombination existiert nicht. Dann bleibt die Leiste beim
    // theme-eigenen deaktivierten Button, eine Warteliste gibt es fuer nichts.
    var soldOut = !!variant && variant.available === false;

    trigger.hidden = !soldOut;
    if (addButton) addButton.hidden = soldOut;
    if (dynamicButton) dynamicButton.hidden = soldOut;

    if (soldOut) {
      trigger.dataset.variantId = variant.id;
      trigger.dataset.variantLabel = stickyLabel(variant);
      markTrigger(trigger, !!loadSubs()[variant.id]);
    }
  }

  function onStickySelectChange(event) {
    if (!event.target || !event.target.closest) return;
    var select = event.target.closest('.sticky-atc-bar select[name="id"]');
    if (!select) return;
    var variants = stickyVariantData();
    if (!variants) return;
    var selected = variants.find(function (variant) {
      return variant.id === Number(select.value);
    });
    updateSticky(selected);
  }

  function listenForVariantChange() {
    if (!window.productId || !window.FoxThemeEvents) return;
    window.FoxThemeEvents.subscribe(window.productId + '__VARIANT_CHANGE', function (variant) {
      updateSticky(variant);
    });
  }

  // ---------------------------------------------------------------------------------------------

  // product-sections.js ersetzt den innerHTML von #buy-buttons. Danach steht dort wieder die
  // Standardbeschriftung aus dem Liquid, also muss der gemerkte Zustand erneut angewendet werden.
  function watchBuyButtons() {
    var target = document.getElementById('buy-buttons');
    if (!target || typeof window.MutationObserver !== 'function') return;
    new window.MutationObserver(function () {
      applyStoredState();
    }).observe(target, { childList: true });
  }

  function init() {
    if (!modal() || !root()) return;

    document.addEventListener('click', onDocumentClick);
    document.addEventListener('change', onStickySelectChange);
    applyStoredState();
    watchBuyButtons();

    var formEl = form();
    if (formEl && !formEl.dataset.hessNotifyBound) {
      formEl.dataset.hessNotifyBound = 'true';
      formEl.addEventListener('submit', onSubmit);
    }

    listenForVariantChange();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
